import { createSlice, createSelector } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { IWorkspace, ITemplate } from '@src/interfaces'
import { Paths } from '@src/enums/paths'
import { RootState } from '@src/store'
export interface IConfigurationState {
  path: string
  variableVisibility: boolean
  newTemplate: ITemplate
  currentTemplate: ITemplate
  allVariables: []
}

const initialState: IConfigurationState = {
  path: Paths.main,
  variableVisibility: false,
  allVariables: [],
  newTemplate: {
    workspace: null,
    title: '',
    document_type: '',
    content: null as any,
    sign_order: null as any,
    tags: [],
    lang: 'es'
  },
  currentTemplate: {
    workspace: null,
    title: '',
    content: '',
    document_type: '',
    sign_order: null as any,
    lang: 'es',
    tags: [],
    token: null
  }
}

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    redirectInit: (state) => {
      state.path = Paths.main
    },
    clearStore: (state) => {
      state = { ...state, ...initialState }
    },
    goTo: (state, action: PayloadAction<Paths>) => {
      state.path = action.payload
    },
    saveVars : (state, action: PayloadAction<{ variables: any }>) => {
      const { variables } = action.payload
      state.allVariables = variables
    },
    activateVariables: (state, action: PayloadAction<{ visibility: boolean }>) => {
      const { visibility } = action.payload
      state.variableVisibility = visibility
    },
    clearTemplateStore: (state, action: PayloadAction<{ isNew: boolean }>) => {
      const { isNew } = action.payload

      if (isNew) state.newTemplate = initialState.newTemplate
      else state.currentTemplate = initialState.currentTemplate
    },
    setCurrentTemplate: (state, action: PayloadAction<{ template: ITemplate }>) => {
      const template = {
        ...action.payload.template,
        document_type: action.payload.template?.document_type?.token
      }
      state.currentTemplate = template
    },
    updateTemplate: (
      state,
      action: PayloadAction<{
        prop: string
        value: string | IWorkspace | string[] | boolean | null
        isNew: boolean
      }>
    ) => {
      const { prop, value, isNew } = action.payload
      state[isNew ? 'newTemplate' : 'currentTemplate'][prop] = value
    }
  }
})

export const show = createSelector(
  (state: RootState) => state.configuration,
  ({ variableVisibility }) => variableVisibility
)

export const fetchVariables = createSelector(
  (state: RootState) => state.configuration,
  ({ allVariables }) => allVariables
)

// Action creators are generated for each case reducer function
export const { redirectInit, goTo, clearTemplateStore, activateVariables, saveVars, setCurrentTemplate, updateTemplate } =
  configurationSlice.actions

export default configurationSlice.reducer
